<div id="kc-conversations-list" class="w-full lg:w-[25%] lg:min-w-[25%] max-h-[45vh] lg:max-h-none overflow-auto flex flex-col gap-6 kc-border">
  <div class="flex flex-col gap-6 pt-3 pb-2 -mb-2 px-5 sticky top-0 bg-surface-0 dark:bg-surface-950 z-10">
    <div class="flex items-center justify-between gap-6 text-color">
      <div class="text-2xl font-medium lead">Chats</div>
      <p-button icon="pi pi-plus" [rounded]="true" size="small" pTooltip="Nuova conversazione" tooltipPosition="bottom" (onClick)="openCreateConversationDialog()"/>
    </div>
  </div>
  <div class="px-5">
    <p-iconField iconPosition="left">
      <p-inputIcon class="pi pi-search"></p-inputIcon>
      <input type="text" pInputText [formControl]="messageSearchControl" placeholder="Cerca" class="w-full"/>
    </p-iconField>
  </div>
  <div class="w-full px-5">
    <kc-conversations-filter-tabs
      [activeTab]="activeTab"
      [filterDaLeggere]="filterDaLeggere"
      [filterDaAccettare]="filterDaAccettare"
      [toReadCount]="toReadCount"
      [toAcceptCount]="toAcceptCount"
      (tabChange)="onTabChangeFromChild($event)"
      (filterToggle)="onFilterToggle($event)"
    />
  </div>
  <div class="flex-1 flex flex-col">
    <div
      *ngFor="let conversation of filteredConversations"
      class="flex items-center gap-2 p-4 cursor-pointer hover:bg-emphasis transition-all conversation-container"
      [ngClass]="{ 'bg-emphasis': conversation.id === activeChat }"
      (click)="selectConversation(conversation, $event)"
    >
      <div class="relative kc-custom-badges">

        @if ((conversation | TakingLong) && conversation.status === ConversationStatus.OPEN && conversation!.notificationCount! === 0) {
          <i class="fa-solid fa-triangle-exclamation absolute -top-1 -right-1 z-10 taking-long" pTooltip="In attesa di risposta"></i>
        }

        <app-conversation-initials
            [rounded]="true"
            [contact]="conversation.contact">
          </app-conversation-initials>


      </div>
      <div class="flex-1 kc-width h-full">
        <div class="flex items-start gap-1 justify-between">
          <div class="flex flex-col">
            <div class="text-color font-bold leading-6 flex items-center gap-2 flex-wrap">
              <span>{{ conversation.contact | contactDisplay: conversation.fromNumber }}</span>
              @if (conversation.priority && conversation.priority !== ConversationPriority.DEFAULT) {
                <div [ngClass]="'priority-' + conversation.priority.toLowerCase()">
                  <i [class]="getPriorityIcon(conversation.priority)"></i>
                  {{ getPriorityLabel(conversation.priority) }}
                </div>
              }
              @if (conversation.contact?.company?.name) {
                <span class="text-xs font-medium px-1.5 py-0.5 rounded" style="background-color: #f5f3ff; color: #6366f1; border: 1px solid #6366f1;">{{ conversation.contact!.company!.name }}</span>
              }
              @if (conversation.contact?.company?.code) {
                <span class="text-xs font-medium px-1.5 py-0.5 rounded" style="background-color: #f5f3ff; color: #6366f1; border: 1px solid #6366f1;">{{ conversation.contact!.company!.code }}</span>
              }
            </div>
            <div class="text-xs text-gray-400 leading-4">{{ conversation.fromNumber }}</div>
          </div>
        </div>
        <div class="flex items-center gap-2">
          @if (conversation.status === ConversationStatus.ASSIGNED_PENDING) {
            <div class="conversation-status-pulse conversation-status-pulse--orange">
              <div class="dot"></div>
              <div class="outline"></div>
            </div>
            <span class="text-sm text-muted-color">Assegnazione Pendente</span>
          } @else if (conversation.status === ConversationStatus.TO_ASSIGN) {
            <div class="conversation-status-pulse conversation-status-pulse--blue">
              <div class="dot"></div>
              <div class="outline"></div>
            </div>
            <span class="text-sm text-muted-color">Conversazione da Assegnare</span>
          } @else if (conversation.status === ConversationStatus.CLOSED) {
            <div class="conversation-status-pulse conversation-status-pulse--red">
              <div class="dot"></div>
              <div class="outline"></div>
            </div>
            <span class="text-sm text-muted-color">Conversazione Chiusa</span>
          } @else {
            <div class="conversation-status-pulse conversation-status-pulse--green">
              <div class="dot"></div>
              <div class="outline"></div>
            </div>
            <span class="text-sm text-muted-color">Conversazione Aperta</span>
          }
        </div>
        <div class="flex items-center gap-5 justify-between mt-1">
          <div class="text-sm text-muted-color leading-5 truncate w-80-prc">
            @if (conversation.lastMessage?.toString() === 'media') {
              <i class="fa-light fa-images"></i>
            } @else {
              {{ conversation.lastMessage }}
            }
          </div>
          <div class="flex items-center gap-1">
            @if (conversation.hasQuote) {
              <i class="fa-duotone fa-light fa-folder text-primary" pTooltip="Preventivo" tooltipPosition="top"></i>
            }
            @if (conversation.status !== ConversationStatus.CLOSED && conversation!.notificationCount! > 0) {
              <div class="card flex justify-center">
                <p-badge value="{{conversation!.notificationCount!.toString()}}" badgeSize="small" severity="info"/>
              </div>
            }
            @if (conversation.status !== ConversationStatus.CLOSED && conversation.hasBeenTouched){
              <i class="fa-duotone fa-light fa-hand text-primary" pTooltip="Già lavorata" tooltipPosition="top"></i>
            }
            @if (conversation.status === ConversationStatus.TO_ASSIGN || conversation.status === ConversationStatus.ASSIGNED_PENDING){
              <p-button icon="fa-light fa-eye" aria-label="Visualizza" pTooltip="Visualizza" tooltipPosition="top" (onClick)="selectConversationAsReadOnly(conversation, $event)" text class="text-primary read-button z-10"/>
            }
            <span class="text-xs text-muted-color whitespace-nowrap">{{ conversation.creationDate | date }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (!selectedConversation) {
  <kc-chat-not-selected class="w-full h-full"/>
} @else if (selectedConversation!.status === 'OPEN' || selectedConversation!.status === 'CLOSED' || viewChat) {
  <kc-chat [conversation]="selectedConversation!" (closeConversationEvent)="closeConversation($event)"
           (unselectConversation)="onUnselectConversation()" (unselectConversationAndReopen)="onUnselectConversationAndReopen()" [isReadOnly]=isReadOnly [closedByMe]="false" class="w-full relative"/>
} @else if (selectedConversation!.status === 'ASSIGNED_PENDING') {
  <kc-chat-invitation (choiceSelected)="handleChoice($event)" [conversation]="selectedConversation"
                      class="w-full h-full"/>
} @else if (selectedConversation!.status === 'TO_ASSIGN') {
  <kc-chat-invitation (choiceSelected)="handleChoice($event)" [conversation]="selectedConversation"
                      class="w-full h-full"/>
}

